export default __webpack_public_path__ + "static/media/nixy.7bdfcb0f.mp4";